import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { IsAuthenticatedGuard } from './_guards/isAuthenticated.gaurd';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';
import { LobbyComponent } from './lobbies/lobby.component';
import { LobbyChatComponent } from './lobbies/chat/lobby-chat.component';
import { LobbyPeopleComponent } from './lobbies/people/lobby-people.component';

@NgModule({
  declarations:[
    LobbyComponent,
    LobbyChatComponent,
    LobbyPeopleComponent
  ],
  entryComponents:[],
  imports: [
    NgbModalModule,
    ApplicationPipesModule,
    RouterModule.forChild([
      { path: ':id', component: LobbyComponent, canActivate: [IsAuthenticatedGuard] },
    ])
  ]
})
  export class LobbyModule{}
